<template>
  <div>
    <b-row>
      <b-col lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <table-promotions
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-boxes mr-2'></i>Promotions</h4>"
          v-else
        ></table-promotions>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TablePromotions from "./TablePromotions";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import ModalCreatePartner from "../notifications/ModalCreatePartner";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "promotions",
  components: {
    TablePromotions,
    SemipolarSpinner,
    ModalCreatePartner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "country_id", label: "Pais", sortable: true },
        { key: "objective", label: "Objetivo", sortable: true },
        { key: "country_id", label: "Pais", sortable: true },
        { key: "redirect_url", label: "URL de redirección", sortable: true },
        { key: "strategic_id", label: "Estrategia", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getPromotions();
  },
  methods: {
    getPromotions() {
      var promotions = store.getters.getPromotions;
      if (promotions.length == 0) {
        this.isLoading = true;
        store.dispatch("getPromotions").then(() => {
          promotions = store.getters.getPromotions;
          shuffleArray([promotions]);
          this.isLoading = false;
          this.items = promotions;
          this.itemsArray = promotions;
        });
      } else {
        shuffleArray([promotions]);
        this.items = promotions;
        this.itemsArray = promotions;
      }
    }
  }
};
</script>
